<template>
  <RouterView />
</template>

<script>
import { READ, CREATE, UPDATE } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Carrier',
      breadcrumb: {
        name: new Promise(resolve => {
          this.$sdk
            .carrier
            .read(this.$route.params.carrierId)
            .then(response => resolve(response.name))
        }),
        route: { name: 'manage-carriers-carrier', params: { carrierId: this.$route.params.carrierId } }
      },
      sidebar: [
        {
          hidden: this.$user.cannot([READ, CREATE, UPDATE], this.$sdk.carrier),
          icon: ['fal', 'cogs'],
          route: { name: 'manage-carriers-carrier-configurations', params: { carrierId: this.$route.params.carrierId } },
          name: 'Configuration'
        },
        {
          hidden: this.$user.cannot(READ, 'carrier_service'),
          icon: ['fal', 'box-open'],
          route: { name: 'manage-carriers-carrier-services', params: { carrierId: this.$route.params.carrierId } },
          name: 'Services'
        },
        {
          hidden: this.$user.cannot(READ, 'carrier_contact'),
          icon: ['fal', 'address-book'],
          route: { name: 'manage-carriers-carrier-contacts', params: { carrierId: this.$route.params.carrierId } },
          name: 'Contacts'
        },
        {
          hidden: this.$user.cannot(READ, 'carrier_locationzone'),
          icon: ['fal', 'mountain'],
          route: { name: 'manage-carriers-carrier-locationcarrierzones', params: { carrierId: this.$route.params.carrierId } },
          name: 'Zones'
        },
        {
          hidden: this.$user.cannot([READ, CREATE, UPDATE], this.$sdk.carrier),
          icon: ['fal', 'map-marked'],
          route: { name: 'manage-carriers-carrier-tracking', params: { carrierId: this.$route.params.carrierId } },
          name: 'Tracking'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.carrier),
          icon: ['fal', 'comment-alt'],
          route: { name: 'manage-carriers-carrier-notes', params: { carrierId: this.$route.params.carrierId } },
          name: 'Notes'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.carrier),
          icon: ['fal', 'clock'],
          route: { name: 'manage-carriers-carrier-times', params: { carrierId: this.$route.params.carrierId } },
          name: 'Times'
        },
        {
          hidden: this.$user.cannot(READ, 'account_attachment'),
          icon: ['fal', 'paperclip'],
          route: { name: 'manage-carriers-carrier-attachments', params: { carrierId: this.$route.params.carrierId } },
          name: 'Attachments'
        }
      ]
    }
  }
}
</script>
